export const googlePlayStoreLink =
  'https://app.mylofamily.com/NUX_FLOW_GROWTH_TRACKER_UTM?utm_source=web&utm_medium=web';
// export const googlePlayStoreLink =
//     "https://play.google.com/store/apps/details?id=in.mylo.pregnancy.baby.app&hl=en_IN&gl=US";

export const branch = {
  CQWrmUBP1lb: googlePlayStoreLink,
  h8smrsgNtnb: googlePlayStoreLink,
  dhnHHAoNtnb: googlePlayStoreLink,
  SBvwKlNtnb: googlePlayStoreLink,
  reqF5mGP1lb: googlePlayStoreLink,
  pn9Rz6EP1lb: googlePlayStoreLink,
  mqQdQPxP1lb: googlePlayStoreLink,
  jgTtsHDP1lb: googlePlayStoreLink,
  ask_now_section_topic_page: googlePlayStoreLink,
  main_follow_cta_topic_page: googlePlayStoreLink,
  follow_cta_in_question_topic_page: googlePlayStoreLink,
  download_banner: googlePlayStoreLink,
  myloclothdiapers: googlePlayStoreLink,
  install: googlePlayStoreLink,
};
export const appleStoreLink =
  'https://app.mylofamily.com/NUX_FLOW_GROWTH_TRACKER_UTM?utm_source=web&utm_medium=web';
